import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useAppStore } from '@/dashboard/store/appStore';
import { storeToRefs } from 'pinia';
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { sendGoogleEvent } from '@/dashboard/helper';
import { onClickOutside } from '@vueuse/core';

export function useHeader() {
  const store = useStore();
  const router = useRouter();

  const appStore = useAppStore();

  const { baseWorkspaceLink } = storeToRefs(appStore);

  const showThemeChanger = ref(false);
  const openThemeChangerBtn = ref();
  const menuChanger = ref();

  const currentPage = computed(() => router.currentRoute.value.path);

  async function themeChanged({ matches }: any) {
    await store.dispatch('themeStore/eventThemeChanging', matches);
  }

  function download() {
    sendGoogleEvent('download_application');
  }

  onClickOutside(openThemeChangerBtn, (event) => (showThemeChanger.value = false), { ignore: [menuChanger] });

  onMounted(async () => {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', themeChanged);
  });

  onUnmounted(() => {
    window.matchMedia('(prefers-color-scheme: dark)').removeEventListener('change', themeChanged);
  });

  return {
    baseWorkspaceLink,
    showThemeChanger,
    openThemeChangerBtn,
    menuChanger,
    currentPage,
    download,
  };
}
